export default __webpack_public_path__ + "./images/mz.2ef77d22.png";